module.exports = __webpack_public_path__ + "ab0561853b98a8146895ec69fd132da2.pdf";